export default __webpack_public_path__ + "static/media/genji-cutting.7ccea757.mp3";